import React from "react";

function Menu() {
  return (
    <div>
      <h1>menu</h1>
    </div>
  );
}

export default Menu;
